import React from 'react'
import { observer } from 'mobx-react'
import { pseudoRandom } from 'ytil'
import { isPendingMessage, MessageListItem } from '~/models'
import { ChatBackend } from '~/stores/chat'
import { Avatar } from '~/ui/app/media'
import { HBox, Label } from '~/ui/components'
import { layout, useStyling } from '~/ui/styling'
import { useChat } from './ChatContext'

export interface Props {
  message: MessageListItem
  backend: ChatBackend
}

const ChatMessageSender = observer((props: Props) => {

  const {message, backend} = props

  const {service} = useChat()

  const sender = React.useMemo(() => {
    if (isPendingMessage(message)) {
      return service.sender
    } else {
      return backend.senders.get(message.from)
    }
  }, [backend.senders, message, service.sender])

  const {colors}   = useStyling()
  const colorIndex = pseudoRandom(sender?.id ?? 0, 0, colors.palettes.default.length)

  //------
  // Rendering

  function render() {
    return (
      <HBox gap={layout.padding.inline.s}>
        {sender?.photoURL != null && (
          <Avatar
            {...sender}
            source={sender.photoURL}
            size={avatarSize}
          />
        )}
        <Label tiny bold color={colors.palette('default', colorIndex)}>
          {sender?.firstName ?? '\u202F'}
        </Label>
      </HBox>
    )
  }


  return render()

})

export default ChatMessageSender

export const avatarSize = {
  width:  12,
  height: 12,
}